<form novalidate *ngIf="lead" [formGroup]="leadForm" (ngSubmit)="onSubmitForm(leadForm.value)">
	<div class="columns">
		<div class="column">
			<div class="mobile-row" *ngIf="lead.type === 'purchase'">
				<div class="field">
					<label class="label" for="rateType">Desired type of rate</label>

					<div class="control has-icons-left">
						<div class="select is-fullwidth">
							<select formControlName="rateType" id="rateType">
								<option *ngFor="let rateType of leadValues.rateTypes" value="{{rateType.key}}">{{rateType.value}}</option>
							</select>
						</div>

						<span class="icon is-left">
							<i class="fas fa-tachometer-alt"></i>
						</span>
					</div>
				</div>

				<div class="field" *ngIf="lead.type === 'purchase'">
					<label class="label" for="buyingProcess">Where are you in the buying process?</label>

					<div class="control has-icons-left">
						<div class="select is-fullwidth">
							<select formControlName="buyingProcess" id="buyingProcess" (change)="buyingProcessChange()">
								<option *ngFor="let option of leadValues.buyingProcess" value="{{option.key}}">{{option.value}}</option>
							</select>
						</div>

						<span class="icon is-left">
							<i class="fas fa-search"></i>
						</span>
					</div>
				</div>
			</div>

			<div class="field" *ngIf="lead.type === 'purchase'">
				<label class="label" for="purchasePrice">Purchase price of new home</label>

				<div class="control has-icons-left">
					<div class="select is-fullwidth">
						<select formControlName="purchasePrice" id="purchasePrice">
							<option *ngFor="let purchasePrice of leadValues.purchasePrices" value="{{purchasePrice.key}}">{{purchasePrice.value}}</option>
						</select>
					</div>

					<span class="icon is-left">
						<i class="far fa-money-bill-alt"></i>
					</span>
				</div>
			</div>

			<div class="field" *ngIf="lead.type === 'refinance'">
				<label class="label" for="cashOut">Cash Out</label>

				<div class="control has-icons-left">
					<div class="select is-fullwidth">
						<select formControlName="cashOut" id="cashOut">
							<option *ngFor="let cashOut of leadValues.cashOuts" value="{{cashOut.key}}">{{cashOut.value}}</option>
						</select>
					</div>

					<span class="icon is-left">
						<i class="far fa-money-bill-alt"></i>
					</span>
				</div>
			</div>

			<div class="field" *ngIf="lead.type === 'refinance'">
				<label class="label" for="propertyValue">Estimated Home Value</label>

				<div class="control has-icons-left">
					<div class="select is-fullwidth">
						<select formControlName="propertyValue" id="propertyValue">
							<option *ngFor="let propertyValue of leadValues.propertyValues" value="{{propertyValue.key}}">{{propertyValue.value}}</option>
						</select>
					</div>

					<span class="icon is-left">
						<i class="far fa-money-bill-alt"></i>
					</span>
				</div>
			</div>

			<div class="field" *ngIf="lead.type === 'refinance'">
				<label class="label" for="firstMortgageBalance">Total Mortgage Balance</label>

				<div class="control has-icons-left">
					<div class="select is-fullwidth">
						<select formControlName="firstMortgageBalance" id="firstMortgageBalance">
							<option *ngFor="let firstMortgageBalance of leadValues.firstMortgageBalances" value="{{firstMortgageBalance.key}}">{{firstMortgageBalance.value}}</option>
						</select>
					</div>

					<span class="icon is-left">
						<i class="far fa-money-bill-alt"></i>
					</span>
				</div>
			</div>

			<div class="field" *ngIf="lead.type === 'purchase'">
				<label class="label" for="downPayment">Estimated down payment</label>

				<div class="control has-icons-left">
					<div class="select is-fullwidth">
						<select formControlName="downPayment" id="downPayment">
							<option *ngFor="let downPayment of leadValues.downPayments" value="{{downPayment.key}}">{{downPayment.value}}</option>
						</select>
					</div>

					<span class="icon is-left">
						<i class="far fa-money-bill-alt"></i>
					</span>
				</div>
			</div>

			<div class="mobile-row">
				<div class="field">
					<label class="label" for="creditRating">Credit type</label>

					<div class="control has-icons-left">
						<div class="select is-fullwidth">
							<select formControlName="creditRating" id="creditRating">
								<option *ngFor="let creditRating of leadValues.creditRatings" value="{{creditRating.key}}">{{creditRating.value}}</option>
							</select>
						</div>

						<span class="icon is-left">
							<i class="far fa-credit-card"></i>
						</span>
					</div>
				</div>

				<div class="field">
					<label class="label" for="veteranMilitary">Are you a veteran or active military?</label>

					<div class="control has-icons-left">
						<div class="select is-fullwidth">
							<select formControlName="veteranMilitary" id="veteranMilitary">
								<option *ngFor="let yesNo of leadValues.yesNos" value="{{yesNo.key}}">{{yesNo.value}}</option>
							</select>
						</div>

						<span class="icon is-left">
							<i class="fas fa-flag"></i>
						</span>
					</div>
				</div>
			</div>
		</div>

		<div class="column">
			<div class="mobile-row">
				<div class="field">
					<label class="label" for="firstName">First Name</label>

					<div class="control has-icons-left">
						<input class="input" type="text" formControlName="firstName" id="firstName">

						<span class="icon is-left">
							<i class="fas fa-user"></i>
						</span>

						<p class="help is-danger" *ngIf="firstNameControl.errors?.required">First Name is required.</p>
						<p class="help is-danger" *ngIf="firstNameControl.errors?.minlength">First Name must be at least {{ firstNameControl.errors.minlength.requiredLength }} letters.</p>
					</div>
				</div>

				<div class="field">
					<label class="label" for="lastName">Last Name</label>

					<div class="control has-icons-left">
						<input class="input" type="text" formControlName="lastName" id="lastName">

						<span class="icon is-left">
							<i class="fas fa-user"></i>
						</span>

						<p class="help is-danger" *ngIf="lastNameControl.errors?.required">Last Name is required.</p>
						<p class="help is-danger" *ngIf="lastNameControl.errors?.minlength">Last Name must be at least {{ lastNameControl.errors.minlength.requiredLength }} letters.</p>
					</div>
				</div>
			</div>

			<div class="mobile-row">
				<div class="field">
					<label class="label" for="phone">Phone</label>

					<div class="control has-icons-left">
						<input class="input" type="phone" formControlName="phone" id="phone" [imask]="phoneMask">

						<span class="icon is-left">
							<i class="fas fa-phone"></i>
						</span>

						<p class="help is-danger" *ngIf="phoneControl.errors?.required">Phone Number is required.</p>
						<p class="help is-danger" *ngIf="phoneControl.errors?.pattern">Invalid Phone Number.</p>
					</div>
				</div>

				<div class="field">
					<label class="label" for="zipCode">Zip Code</label>

					<div class="control has-icons-left">
						<input class="input" type="text" formControlName="zipCode" id="zipCode" [imask]="zipMask">

						<span class="icon is-left">
							<i class="fas fa-map-marker-alt"></i>
						</span>

						<p class="help is-danger" *ngIf="zipCodeControl.errors?.required">Zip Code is required.</p>
						<p class="help is-danger" *ngIf="zipCodeControl.errors?.pattern">Zip Code must be 5 digits.</p>
					</div>
				</div>
			</div>

			<div class="field">
				<div class="control">
					<input type="hidden" formControlName="propertyType">
					<input type="hidden" formControlName="propertyUse">
					<input type="hidden" formControlName="currentVA" *ngIf="lead.type === 'refinance' && veteranMilitaryControl.value === 'yes'">
					<input type="hidden" formControlName="currentFHA" *ngIf="lead.type === 'refinance'">
					<input type="hidden" formControlName="email">
					<input type="hidden" name="universal_leadid" id="leadid_token" value="" />
					<button type="submit" class="button is-success is-fullwidth is-size-4 is-size-5-mobile has-text-weight-black has-shadow-large" [disabled]="! leadForm.valid || disableSubmit">Get Rates &#12297;</button>
				</div>
			</div>

			<div class="field">
				<p class="tcpa is-size-7 has-text-grey-dark">
					<input type="hidden" id="leadid_tcpa_disclosure_form">
					<label for="leadid_tcpa_disclosure_form">
						We take your privacy seriously. By clicking the button above, You agree that we can share your personal data with third parties, such as our mortgage partners, service providers and other affiliates, and that we can use this data for marketing and analytics, and to make your experience easier. you are also providing your<b>express written consent</b> to have your information shared and to be matched with up to five <a href="/approved-lenders" target="_new" rel="nofollow">approved lenders</a> and for them, or their authorized third party, to call you at the number you have provided including through automated means such as autodialing, text SMS/MMS (charges may apply), and prerecorded messaging, and/or via email, even if your telephone number is a cellular phone number or on a corporate, state, or the National Do Not Call Registry, and you agree to our Privacy Policy <a href="/privacy" target="_new" rel="nofollow">Privacy Policy</a>. Consent is not required as a condition to utilize FreeRateUpdate's services, you may choose to use our services by calling 855-315-7283. Consent is not contingent on the purchase and/or use of any services being offered by a Lender.
					</label>
				</p>

				<p class="is-flex is-flex-centered">
						<img src="/assets/images/bbb-a-plus-rating.gif" alt="BBB A+ Rated">
				</p>
			</div>
		</div>
	</div>
</form>
